import { Currency } from "../../interfaces/screens/billing";

/**
 * Converts an amount from the base currency to a target currency using the exchange rate.
 *
 * @param amount The amount in the base currency to convert.
 * @param currency The target currency object, which includes the exchange rate.
 * @returns The converted amount. Returns the original amount if conversion is not possible.
 */
export const getAmountInCurrency = (
  amount: number,
  currency?: Currency,
): number => {
  if (currency && currency.exchange_rate) {
    return amount * currency.exchange_rate;
  }
  return amount;
};
